import { render, staticRenderFns } from "./historyList.vue?vue&type=template&id=19f62d9c&scoped=true"
import script from "./historyList.vue?vue&type=script&lang=js"
export * from "./historyList.vue?vue&type=script&lang=js"
import style0 from "./historyList.vue?vue&type=style&index=0&id=19f62d9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f62d9c",
  null
  
)

export default component.exports